import { inject, Injectable, signal } from '@angular/core';
import { filterFirst } from 'ngx-unificator/rxjs';
import { catchError, tap } from 'rxjs/operators';
import { StaticContentService } from './static-content.service';
import { EMPTY } from 'rxjs';
import { CookieService } from 'ngx-unificator/services';
import { COOKIE_ID_ID, PTAG_KEY } from './stag-detector.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RestrictSignupService {

  private _static = inject(StaticContentService);
  private _cookie = inject(CookieService);
  private _router = inject(Router);

  public isSignupRestricted = signal<boolean>(false);

  /**
   * Checks if registration is available for the user's country and updates the signup restriction state.
   */
  public checkAvailableRegistration() {
    return this._static.item({ slug: 'restrict-country-registration' }).pipe(
      filterFirst(data => Boolean(data)),
      tap((data) => {
        this.isSignupRestricted.set(data?.length);
        if (Boolean(data?.length) &&
          (!this._cookie.check('registered') && !this._cookie.check(PTAG_KEY) && !this._cookie.check(COOKIE_ID_ID))
        ) {
          this._router.navigate(['/403']);
        }
      }),
      catchError(() => EMPTY),
    );
  }
}
